module.exports = __webpack_public_path__ + "static/media/undo.aad6086a.png";